// extracted by mini-css-extract-plugin
export default {"BookingDetail":"BookingDetail_BookingDetail__NrFsU","BookingDetailContainer":"BookingDetail_BookingDetailContainer__R+rOo","Row":"BookingDetail_Row__nGI+U"};